/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { noop } from "lodash";
import debounce from "lodash.debounce";
import { useCallback } from "react";

/**
 * @param {(search: string) => void} fn 
 * @param {number} wait 
 */
export function useDebouncedChange (fn = noop, wait) {
    const debounced = debounce(fn, wait);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useCallback(debounced, [wait]);
}
